// extracted by mini-css-extract-plugin
export default {"other":"index_other_tKvXQ","judgesImg":"index_judgesImg_0g4sT"};